import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'

import { Box, Button, Form } from '@domain-group/suit-theme'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

import type { UseFormPayload } from '@domain-group/react-hooks'

import useTagInputField from './hooks/useTagInputField'

import TagsList from './components/TagsList'

interface TagsInputProps {
  formPayload: UseFormPayload,
  fieldKey: string,
  fieldName: string,
}

const TagInputField = (props: TagsInputProps) => {
  const {
    fieldKey,
    fieldName,
    formPayload,
  } = props

  const useTagInputFieldPayload = useTagInputField({ fieldKey, fieldName, formPayload })
  const {
    callbacks: {
      handleAddButton,
      handleInputChange,
      handleKeyDown,
      handleRemoveTag,
      setInputValue,
      setShowInput,
    },
    fieldsArray,
    hasTags,
    inputRef,
    inputValue,
    showInput,
  } = useTagInputFieldPayload

  return (
    <Form.Field label={snakeToTitleCase(fieldName)}>
      <Box marginBottom={showInput && hasTags ? 'medium' : ''} flexWrap="wrap" style={{ rowGap: '4px' }}>
        <TagsList
          callbacks={{ handleRemoveTag }}
          fieldsArray={fieldsArray}
          hasTags={hasTags}
        />

        {hasTags && !showInput && (
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => setShowInput(true)}
            size="tiny"
            width="fit-content"
          >
            Add {snakeToTitleCase(fieldName)}
          </Button>
        )}
      </Box>

      {(showInput || !hasTags) && (
        <Box justifyContent="space-between">
          <input
            name={`${fieldKey}.${fieldName}`}
            onChange={e => handleInputChange(e)}
            onFocus={() => setShowInput(true)}
            onKeyDown={e => handleKeyDown(e)}
            ref={inputRef}
            style={{ width: '100%' }}
            type="text"
            value={inputValue}
          />

          <Button
            buttonStyle="secondaryEdit"
            marginLeft="small"
            // @ts-expect-error TS2322
            paddingX="large"
            onClick={() => handleAddButton()}
            style={{ width: 'auto' }}
          >
            Add
          </Button>

          {showInput && inputValue.length > 0 && (
            <Button
              buttonStyle="secondaryUtility"
              marginLeft="small"
              // @ts-expect-error TS2322
              paddingX="large"
              onClick={() => { setShowInput(false); setInputValue('') }}
              style={{ width: 'auto' }}
            >
              Cancel
            </Button>
          )}
        </Box>
      )}
    </Form.Field>
  )
}

export default TagInputField
